var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"kyc-chart-button",class:_vm.classList,on:{"click":_vm.dispatchClickEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }